export enum PaymentMPExternalId {
  PREMIUM = '1',
  PDA = '2',
  NULINGA = '3',
  MIGURU = '4',
  DOCTORCV = '5'
}
